import { useState } from "react";

const Dropdown = ({ label, children }) => {

    const [show, setShow] = useState(false);

    const toggle = (e) => {
        e.preventDefault();
        setShow(!show);
    }

    return (
        <div class={"dropdown" + (show? ' show' : '')}>
            <button class="btn btn-secondary dropdown-toggle" onClick={toggle}
                type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded={show}>
                {label}
            </button>
            <div class={"dropdown-menu"  +( show? ' show' : '')} aria-labelledby="dropdownMenuButton">
                {children}
            </div>
        </div>
    )
}

export default Dropdown;